import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/app/user'
import blogCategories from './modules/blog/blogCategories'
import blogPosts from './modules/blog/blogPosts'
import blogTags from './modules/blog/blogTags'
import blogGallery from './modules/blog/blogGallery'
// ui global state
import snackbar from './modules/ui/snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    blogCategories,
    blogPosts,
    blogTags,
    blogGallery,
    // all ui state
    snackbar
  },
  strict: true
})
